<template>
  <div class="minimap">
    <img :src="img">
    <div class="I1Btn" :style="{top:(y/2) + 'px',left:(x/2)+'px'}">X</div>
  </div>
</template>

<script>
export default {
  name: "Minimap2",
  props: ["img", "x", "y"]
}
</script>

<style scoped>
.minimap{
  width: 650px;
  height: 400px;
  position: relative;
}
.minimap img{
  width: 650px;
  height: 400px;
  object-fit: contain;
  
}
.I1Btn {
  position:absolute;
  width: 10px;
  height: 10px;
  color:red;
  border-radius: 30%;
  cursor: pointer;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  vertical-align: middle;
  font-size: 1.3em;
}
</style>